
type Inputs = {
	width: number
	height: number
};

export const useAspectRatio = (dims: Inputs) => {
	// A/R for iDXA MEB files
	if (dims.width > 125 || dims.height > 225) {
		return {
			aspectRatio: dims.width / (dims.height * 1.25),
		};
	}

	// A/R for Prodigy DFB files
	return {
		aspectRatio: dims.width / (dims.height * 2.666),
	};
};
